/**
 * Network Configuration
 *
 * This module contains all network-related constants and utility functions
 * for handling blockchain networks, currencies, and explorers.
 */

// Network configurations with chain IDs, names, currencies, and explorer URLs
export const NETWORKS = {
  mainnet: {
    chainId: 1,
    name: "Ethereum Mainnet",
    currency: "ETH",
    explorer: "https://etherscan.io",
    string: "mainnet",
    displayString: "mainnet",
  },
  goerli: {
    chainId: 5,
    name: "Ethereum Goerli",
    currency: "ETH",
    explorer: "https://goerli.etherscan.io",
    string: "goerli",
    displayString: "goerli",
  },
  matic: {
    chainId: 137,
    name: "Polygon Mainnet",
    currency: "MATIC",
    explorer: "https://polygonscan.com",
    string: "matic",
    displayString: "polygon",
  },
  mumbai: {
    chainId: 80001,
    name: "Polygon Mumbai",
    currency: "MATIC",
    explorer: "https://mumbai.polygonscan.com",
    string: "mumbai",
    displayString: "mumbai",
  },
  sepolia: {
    chainId: 11155111,
    name: "Ethereum Sepolia",
    currency: "ETH",
    explorer: "https://sepolia.etherscan.io",
    string: "sepolia",
    displayString: "sepolia",
  },
  amoy: {
    chainId: 80002,
    name: "Polygon Amoy",
    currency: "MATIC",
    explorer: "https://amoy.polygonscan.com",
    string: "amoy",
    displayString: "amoy",
  },
}

// Map chain IDs to network strings
export const CHAIN_ID_TO_NETWORK = {
  1: "mainnet",
  5: "goerli",
  137: "matic",
  80001: "mumbai",
  11155111: "sepolia",
  80002: "amoy",
}

// Utility functions
export const getNetworkByChainId = (chainId) => {
  const networkString = CHAIN_ID_TO_NETWORK[chainId]
  return networkString ? NETWORKS[networkString] : null
}

export const getNetworkByName = (name) => {
  return NETWORKS[name] || null
}

export const getNetworkInfo = (chainId) => {
  const network = getNetworkByChainId(chainId)
  return (
    network || {
      name: "",
      string: "",
      displayString: "",
      currency: "",
    }
  )
}

export const getExplorerUrl = (network) => {
  return NETWORKS[network]?.explorer || ""
}

export const getNetworkName = (network) => {
  return NETWORKS[network]?.name || network
}

export const getNetworkCurrency = (network) => {
  return NETWORKS[network]?.currency || ""
}
